import { memo } from 'react'

import { useLocation } from 'react-router-dom'

import { ROUTES } from 'Constants'
import Footer from './Footer'
import Header from './Header'
import { Container, Content, LoginContent } from './Styles'

const AuthLayout = ({ children }) => {
  const location = useLocation()

  return (
    <Container>
      <Header noHelp={location.pathname !== ROUTES.LOGIN()} />
      <LoginContent>
        {children}
      </LoginContent>
      <Footer />
    </Container>
  )
}

AuthLayout.whyDidYouRender = true

export default memo(AuthLayout)
